import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"
import AdvancedFacetMixin from '../mixins/advanced_facet_mixin'
import RangeSelector from '../../utils/range_selector'
import createReactClass from 'create-react-class'

export default createReactClass({
  mixins: [AdvancedFacetMixin],

  getInitialState() {
    return {autocomplete: null};
  },

  getDefaultProps() {
    return {
      form: null,
      map: null,
      filters: [],
      options: {},
      general_inputs:
        ['is_free_standing'],
      location_inputs:
        ['on_camping', 'on_vineyard', 'near_country_side', 'near_village', 'near_city',
          'near_hills', 'near_mountains', 'near_public_transport'],
      facility_inputs:
        ['has_fireplace', 'tennis_at_object'],
      activity_inputs:
        ['near_bike', 'near_mountainbike', 'near_hiking', 'near_horseriding', 'near_watersports',
          'near_fishsport', 'near_mountainsports', 'near_themepark']
    };
  },

  render() {
    const filters = this.props.filters || {};
    const self = this;
    const min_year = filters['min_year'] || this.props.options.min_year;
    const max_year = filters['max_year'] || this.props.options.max_year;
    const min_plot_space = filters['min_plot_space'];
    const max_plot_space = filters['max_plot_space'];
    const min_living_space = filters['min_living_space'];
    const max_living_space = filters['max_living_space'];

    const general_inputs = ['maintenance'].map(function(filter) {
      const options = self.props.options[filter].map(option => {
        return { value: option, label: I18n.t(`search.${filter}.${option}`) }
      })

      return self.createSelect2Input(filter, options, false, I18n.t(`search.placeholders.${filter}`), 'input--yellow input--small');
    });
    const sub_type_options = this.props.options.object_sub_types.map(filter => {
      return { value: filter, label: I18n.t(`search.object_sub_type.${filter}`) }
    });

    general_inputs.push(self.createSelect2Input(
        'object_sub_type', sub_type_options, false, I18n.t('search.placeholders.object_sub_type'), 'input--yellow input--small'
      )
    );

    const general_sub_inputs = [];
    const room_options = [1, 2, 3, 4, 5].map(i => {
      return { value: i, label: I18n.t('search.attributes.rooms', { count: i }) }
    });
    general_sub_inputs.push(self.createSelect2Input(
        'rooms', room_options, false, I18n.t('search.placeholders.rooms'), 'input--yellow input--small'
      )
    );
    const floor_options = [1, 2, 3, 4, 5].map(i => {
      return { value: i, label: I18n.t('search.attributes.floors', {count: i}) }
    });

    general_sub_inputs.push(self.createSelect2Input(
        'floors', floor_options, false, I18n.t('search.placeholders.floors'), 'input--yellow input--small')
    );

    ['recent', 'is_free_standing'].map(filter => general_sub_inputs.push(self.createInput(filter)));

    general_sub_inputs.push(self.createRangeInput('plot_space', min_plot_space, max_plot_space, this.props.options.plot_space_options, null, 'input--white'));
    general_sub_inputs.push(self.createRangeInput('living_space', min_living_space, max_living_space, this.props.options.living_space_options, null,  'input--white'));

    const location_inputs = ['near_beach', 'near_water'].map(filter => self.createInput(filter));
    const location_sub_inputs = this.props.location_inputs.map(filter => self.createInput(filter));

    const facility_inputs = ['has_swimmingpool', 'wheelchair_accessible'].map(filter => self.createInput(filter));
    const facility_sub_inputs = this.props.facility_inputs.map(filter => self.createInput(filter));

    const activity_inputs = ['near_skiing', 'near_golf'].map(filter => self.createInput(filter));
    const activity_sub_inputs = this.props.activity_inputs.map(filter => self.createInput(filter));

    const general    = this.createSubForm(I18n.t('search.form_labels.general'), general_inputs, general_sub_inputs, 'general');
    const location   = this.createSubForm(I18n.t('search.form_labels.location'), location_inputs, location_sub_inputs, 'location');
    const facilities = this.createSubForm(I18n.t('search.form_labels.facilities'), facility_inputs, facility_sub_inputs, 'facilities');
    const activities = this.createSubForm(I18n.t('search.form_labels.activities'), activity_inputs, activity_sub_inputs, 'activities');
    const areas      = this.generateAreaInputs();

    return <div>
      {general}
      {location}
      {facilities}
      {activities}
      {areas}
    </div>;
  }
});
